const autoSuggest = (router) => {
    return fetch(`/holiday/api/autoSuggestv1?text=${router.searchText}`).then((response) => response.json())
}
export default autoSuggest;